const toCamel = (property: string): string => {
  let camel = '';
  const propertyArray = property.split('_');
  for (let i = 0; i < propertyArray.length; i += 1) {
    let propertyValue = propertyArray[i];
    if (i > 0) {
      propertyValue = propertyValue.charAt(0).toUpperCase() + propertyValue.slice(1);
    }
    camel += propertyValue;
  }
  return camel;
};

const toSnake = (property: string): string => {
  let snake = '';
  property.split('').forEach((key) => {
    if (key === key.toUpperCase()) {
      snake = `${snake}_${key.toLowerCase()}`;
    } else {
      snake += key.toLowerCase();
    }
  });
  return snake;
};

const arrayIterate = (propertyValue: any, func: any): any[] => {
  const arrItem: any[] = [];
  for (let i = 0; i < propertyValue.length; i += 1) {
    if (typeof propertyValue[i] === 'string' || typeof propertyValue[i] === 'number' || typeof propertyValue[i] === 'boolean') {
      arrItem.push(propertyValue[i]);
    } else if (propertyValue[i]) {
      const prop = func(propertyValue[i]);
      arrItem.push(prop);
    }
  }
  return arrItem;
};

const snakeToCamel = (snake: any) => {
  let camel: any = {};
  if (Array.isArray(snake)) {
    camel = arrayIterate(snake, snakeToCamel);
  } else if (typeof snake === 'string' || typeof snake === 'number' || typeof snake === 'boolean') {
    camel = snake;
  } else {
    Object.keys(snake).forEach((property) => {
      let propertyValue = snake[property];
      if (Array.isArray(propertyValue)) {
        propertyValue = arrayIterate(propertyValue, snakeToCamel);
      }
      camel[toCamel(property)] = snakeToCamel(propertyValue);
    });
  }
  return camel;
};

const camelToSnake = (camel: any) => {
  let snake: any = {};
  if (Array.isArray(camel)) {
    snake = arrayIterate(camel, camelToSnake);
  } else if (typeof camel === 'string' || typeof camel === 'number' || typeof camel === 'boolean') {
    snake = camel;
  } else {
    Object.keys(camel).forEach((property) => {
      let propertyValue = camel[property];
      if (Array.isArray(propertyValue)) {
        propertyValue = arrayIterate(propertyValue, camelToSnake);
        snake[toSnake(property)] = propertyValue;
      } else {
        snake[toSnake(property)] = camelToSnake(propertyValue);
      }
    });
  }
  return snake;
};

export default { snakeToCamel, camelToSnake };
